<template>
    <div class="users-page">
        <!-- Header -->
        <div class="page-header">
            <div>
                <h1>{{ $t('menu.users.page.userOverview.header') }}</h1>
                <p class="page-subtitle">{{ $t('menu.users.page.subtitle', { count: user.users.length }) }}</p>
            </div>
            <button class="appButton" @click="addUser()">
                <i class="bx bx-plus" style="margin-right: 0.25rem;"></i>
                {{ $t('menu.users.page.userOverview.add') }}
            </button>
        </div>

        <!-- Users table -->
        <div class="tap-card table-wrap">
            <table class="tap-table">
                <thead>
                    <tr>
                        <th>{{ $t('menu.users.page.userOverview.email') }}</th>
                        <th>{{ $t('menu.users.page.userOverview.userName') }}</th>
                        <th>{{ $t('menu.users.page.userOverview.userDepartment') }}</th>
                        <th>{{ $t('menu.users.page.userOverview.userLevel') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="u in user.users" :key="u.p_id">
                        <td>
                            <div class="user-email-cell">
                                <div class="user-avatar-sm">{{ getInitials(u.username) }}</div>
                                <span class="cell-mono">{{ u.email }}</span>
                            </div>
                        </td>
                        <td class="cell-name">{{ u.username }}</td>
                        <td>
                            <span class="tap-badge tap-badge-accent">{{ u.department_name }}</span>
                        </td>
                        <td>
                            <span class="role-text">{{ u.user_group_name }}</span>
                        </td>
                        <td class="cell-action">
                            <button class="row-action-btn" @click="editUser(u.p_id)">
                                <i class="bx bx-edit-alt"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import { storeToRefs } from 'pinia'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();
        const { users } = storeToRefs(user)

        user.getUsers();

        return { user }
    },
    methods: {
        getInitials(name) {
            if (!name) return '?';
            return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
        },
        async addUser() {
            this.$router.push({ name: 'add-user' });
        },
        async editUser(p_id) {
            const found = this.user.users.find(u => u.p_id === p_id);
            if (found) {
                this.user.editUser = { ...found };
            }
            this.$router.push({ name: 'edit-user', params: { p_id: p_id } });
        }
    }
}
</script>

<style scoped>
.users-page {
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}
.page-subtitle {
    color: #9aa0a8;
    font-size: 0.875rem;
    margin-top: 0.125rem;
}

.table-wrap {
    overflow-x: auto;
    border-radius: 12px;
    animation: fadeIn 0.4s ease-out;
}

.user-email-cell {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}
.user-avatar-sm {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: rgba(117, 35, 35, 0.12);
    border: 1px solid rgba(117, 35, 35, 0.15);
    color: #a63c3c;
    font-family: 'IBM Plex Sans', system-ui, sans-serif;
    font-weight: 600;
    font-size: 0.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.cell-name {
    color: #e8eaed;
    font-weight: 500;
}
.cell-mono {
    font-family: 'IBM Plex Mono', monospace;
    font-size: 0.8125rem;
    color: #9aa0a8;
}
.role-text {
    font-size: 0.8125rem;
    color: #9aa0a8;
}
.cell-action {
    text-align: right;
    padding-right: 1rem;
}
.row-action-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(255, 255, 255, 0.03);
    color: #9aa0a8;
    font-size: 1rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}
.row-action-btn:hover {
    background: rgba(117, 35, 35, 0.1);
    border-color: rgba(117, 35, 35, 0.2);
    color: #a63c3c;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>
